import '../style/yearpage.css';
import { useNavigate } from 'react-router-dom';
import IsraelImage from '../components/israel.webp';
import LuxembourgImage from '../components/luxembourg.jpg';
import GeorgiaImage from '../components/georgia.webp';

function Year2023() {
    const navigate = useNavigate(); // Initialize the navigate function
  
    // Function to handle container clicks
    const handleContainerClick = (path) => {
      navigate(path); // Navigate to the specified path
    };

    const handleBackClick = () => {
      navigate('/'); // Navigate to the home page
    };
  
    return (
      <div className="year-page">
        <h1>2023 Photos</h1>
        <button 
        className="back-button" 
        onClick={handleBackClick}
      >
        ← Back 
      </button>
        <div className="location-grid">
          {/* Israel Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/israel')} // Redirect to /israel
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${IsraelImage})` }}
            ></div>
            <p className="location-name">Israel</p>
          </div>
  
          {/* Luxembourg Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/luxembourg')} // Redirect to /luxembourg
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${LuxembourgImage})` }}
            ></div>
            <p className="location-name">Luxembourg</p>
          </div>
  
          {/* Georgia Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/georgia')} // Redirect to /georgia
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${GeorgiaImage})` }}
            ></div>
            <p className="location-name">Georgia</p>
          </div>
        </div>
      </div>
    );
  }
  
export default Year2023;